function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  xlinkHref: "#a",
  id: "d",
  patternTransform: "matrix(1.05 0 0 1.425 430 440)"
}), /*#__PURE__*/React.createElement("pattern", {
  xlinkHref: "#a",
  id: "c",
  patternTransform: "matrix(1.32124 -.09972 .08466 1.12181 362 488)"
}), /*#__PURE__*/React.createElement("pattern", {
  xlinkHref: "#a",
  id: "b",
  patternTransform: "matrix(1.09045 0 0 1.86827 351.786 352.846)"
}), /*#__PURE__*/React.createElement("pattern", {
  id: "a",
  patternTransform: "scale(10)",
  height: 10,
  width: 10,
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 0.81,
  cx: 2.567
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 2.33,
  cx: 3.048
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 2.415,
  cx: 4.418
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 3.029,
  cx: 1.844
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 1.363,
  cx: 6.08
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 4.413,
  cx: 5.819
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 4.048,
  cx: 4.305
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 3.045,
  cx: 5.541
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 5.527,
  cx: 4.785
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 5.184,
  cx: 2.667
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 1.448,
  cx: 7.965
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 5.049,
  cx: 7.047
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 0.895,
  cx: 4.34
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 0.34,
  cx: 7.125
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 1.049,
  cx: 9.553
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 2.689,
  cx: 7.006
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 2.689,
  cx: 8.909
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 4.407,
  cx: 9.315
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 3.87,
  cx: 7.82
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 5.948,
  cx: 8.27
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 7.428,
  cx: 7.973
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 8.072,
  cx: 9.342
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 9.315,
  cx: 8.206
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 9.475,
  cx: 9.682
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 6.186,
  cx: 9.688
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 6.296,
  cx: 3.379
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 8.204,
  cx: 2.871
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 8.719,
  cx: 4.59
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 9.671,
  cx: 3.181
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 7.315,
  cx: 5.734
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 6.513,
  cx: 6.707
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 9.67,
  cx: 5.73
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 8.373,
  cx: 6.535
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 7.154,
  cx: 4.37
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 7.25,
  cx: 0.622
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 5.679,
  cx: 0.831
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 8.519,
  cx: 1.257
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 6.877,
  cx: 1.989
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 3.181,
  cx: 0.374
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 1.664,
  cx: 1.166
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 0.093,
  cx: 1.151
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 10.093,
  cx: 1.151
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 4.451,
  cx: 1.302
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.45,
  cy: 3.763,
  cx: 3.047
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M347.063 400s2.827 1.909 4.293 2.778c3.046 1.804 6.334 3.187 9.344 5.05 4.213 2.607 9.051 4.196 13.89 4.167 1.845-.01 4.268-.343 5.43 1.894.753 1.452 4.166.505 4.166.505 1.144-1.175 2.725 2.586 3.157 4.167.925 3.383.848 7.397 2.904 9.723 2.544 2.877 3.002 6.146 4.925 9.47.865 1.496 2.778 5.303 2.778 5.303 1.99.364 2.878.177 3.535-.126l-10.733-30.304-41.542-15.153zM315.415 390.856s2.043 10.35 4.546 14.9c2.22 4.033 5.42 7.531 7.829 11.364 1.744 2.776 4.311 4.943 6.566 7.324 2.087 2.204 4.455 4.702 6.945 6.44 2.507 1.749 3.9 4.093 6.187 6.186 2.898 2.655 6.566 5.985 10.101 7.703 6.32 3.072 8.949 7.84 9.66 7.986.322.256 4.672 0 4.672 0l4.861 8.05 6.945 4.42 5.303 3.282c.394 3.224 3.252.807 4.925-.126l1.389-1.262-76.898-77.53z",
  fill: "#dbba07",
  fillRule: "evenodd",
  stroke: "red",
  strokeWidth: 0.354
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M328.677 377.06c-3.586 2.325-8.543 6.37-10.48 7.386-4.477 2.348-3.154 3.108-4.294 4.546 5.984-1.886 11.715-4.262 17.867-7.829 4.204-3.814 8.457-7.58 11.68-12.374.981-1.485-.755-1.03-1.894-.884-4.67 2.597-5.223 4.063-7.576 5.998-2.488 2.045-3.577 2.037-5.303 3.156z",
  fill: "#dbba07",
  fillRule: "evenodd",
  stroke: "red",
  strokeWidth: 0.354,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M328.868 377.202c-3.586 2.325-8.543 6.37-10.48 7.386-4.477 2.348-3.154 3.108-4.294 4.546 5.985-1.886 11.715-4.262 17.867-7.829 4.205-3.814 8.457-7.58 11.68-12.374.981-1.485-.755-1.03-1.894-.884-4.67 2.597-5.223 4.063-7.576 5.998-2.488 2.046-3.577 2.037-5.303 3.156z",
  fill: "url(#b)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.063,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M315.42 390.712s2.043 10.35 4.546 14.9c2.219 4.033 5.42 7.531 7.828 11.364 1.745 2.776 4.312 4.943 6.566 7.324 2.088 2.204 4.456 4.702 6.945 6.44 2.507 1.749 3.9 4.093 6.187 6.187 2.9 2.654 6.567 5.984 10.102 7.702 6.32 3.072 8.948 7.84 9.66 7.987.322.256 4.672 0 4.672 0l4.86 8.05 6.946 4.419 5.303 3.283c.394 3.223 3.252.806 4.924-.127l1.39-1.262-76.898-77.53z",
  fill: "url(#c)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.063
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M347.114 399.93s2.826 1.909 4.293 2.778c3.046 1.805 6.333 3.188 9.344 5.05 4.213 2.608 9.05 4.196 13.89 4.167 1.845-.01 4.267-.343 5.429 1.895.753 1.45 4.167.505 4.167.505 1.143-1.175 2.724 2.585 3.156 4.166.925 3.384.849 7.398 2.905 9.723 2.543 2.877 3.002 6.146 4.924 9.47.865 1.496 2.778 5.304 2.778 5.304 1.99.363 2.879.176 3.536-.127l-10.733-30.304-41.543-15.152z",
  fill: "url(#d)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.063
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M316.304 390.586s1.92 3.354 4.167 5.43c-.298 3.277 1.413 4.232 2.14 6.208 5.213 9.114 6.393 9.957 9.507 14.574 3.225 4.78 6.311 7.07 9.581 10.532 1.268 1.343 3.468 2.802 4.85 4.026 2.031 1.796 4.443 3.752 6.53 5.481 2.843 2.357 4.594 4.009 7.502 6.283 2.685 2.1 5.142 3.39 7.62 5.424 1.383 1.135 2.105 3.448 3.535 4.04.972.403 3.335-.268 3.335-.268l3.099 4.383s2.218 2.528 3.55 3.535c1.884 1.423 6.357 2.569 6.357 2.569l3.283 3.803c2.272 2.103 2.134 1.708 2.852 1.635l6.566-7.07c1.515-1.263 1.515-2.358 0-3.284 0 0-6.213-5.571-9.091-8.586-3.298-3.454-5.744-7.722-9.344-10.859-2.342-2.04-5.615-3.257-7.703-5.556-1.974-2.174-2.322-5.038-4.167-7.323-3.493-4.328-12.879-10.607-12.879-10.607l-8.586-9.597c-.581-.665-1.14-1.42-1.39-3.409l-.2-2.377c1.7-.456 3.521-.173 5.556 1.389 0 0 8.505 4.509 13.206 6.12 2.359.807 4.7 1.205 7.145 1.693 2.186.436 6.127.166 7.816 1.62 1.689 1.454 3.525 4.813 3.727 3.803l2.036-1.256c3.17 1.273 3.557 3.497 3.803 5.386.26 1.992.065 3.836.594 5.793 1.072 3.962 3.58 7.476 5.482 11.112.945 1.804 2.227 5.482 2.227 5.482 1.01 1.95 2.02 2.054 3.03 2.02 3.477-.358 6.54-1.748 9.345-3.788 1.501-1.01 1.085-2.02.252-3.03 0 0-3.448-7.607-4.546-11.617-.968-3.537-.64-7.37-1.767-10.86-.753-2.328-2.138-4.403-3.283-6.565-1.13-2.132-1.883-4.557-3.536-6.314-2.88-3.06-7.138-6.235-10.606-6.818-3.283-.553-6.477-2.485-9.85-3.788 0 0-7.493-2.657-11.111-4.293-1.99-.9-4.068-1.712-5.808-3.03-1.567-1.188-2.505-3.068-4.041-4.294-1.298-1.036-2.878-1.657-4.293-2.525-2.13-1.308-6.314-4.041-6.314-4.041l-1.01-1.515c-8.948 8.056-17.876 14.617-29.168 20.329z",
  fill: "#dbba07",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.063
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M314.663 388.818c-1.212.937-.838 1.6-.758 2.4.1.998 1.224 2.015 1.894 2.462 0 0 1.468-.382 2.4-.695 2.693-.906 5.155-2.424 7.575-3.914 2.57-1.579 6.262-3.008 7.324-5.304.433-.207.979-.129 1.389-.378 1.806-1.1 2.801-3.173 4.293-4.672a85.336 85.336 0 015.303-4.925c.893-.756 2.778-2.146 2.778-2.146-.715-1.58-1.43-2.187-2.146-2.778-.8-.974-1.474-1.148-2.273-.442 0 0-2.92 2.917-4.167 4.356-.827.954-1.362 2.156-2.273 3.03-1.18 1.132-2.617 2.037-4.104 2.715-.53.242-1.41 1.415-1.641 2.336-1.432.287-5.16 2.264-7.829 3.662-1.688.885-3.448 1.978-5.114 2.904-.872.485-2.651 1.39-2.651 1.39z",
  fill: "#dbba07",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.063
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M333.214 383.88c3.348 4.19 6.52 7.784 10.09 13.304.773.476 1.428.476 1.964 0 .502-.887 1.145-1.611.268-4.108-2.184-4.24-4.734-8.375-8.572-12.142l-2.053 2.41z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.76
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M333.214 379.326c-.619.343-.943 1.476-.535 2.054.396.561 1.839.464 2.053.179.268-.358.49-1.221.179-1.697-.325-.496-1.178-.822-1.697-.536z",
  fill: "#dbba07",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 0.76
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M324.33 384.371c-1.075-.117-2.12.035-2.723.625 0 0 2.215 2.4 2.902 3.929.199.442-.402.893-.402.893.58.15 2.17.852 2.991.044l-.178-.937c-.218-.417-.707-.968-1.161-1.384-1.305-1.434-.759-2.054-1.429-3.17z",
  fill: "#dbba07",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 0.76,
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M338.438 372.764c.423-.468.327-1.022 1.383-1.384.583-.223 1.119-.52 2.277.179.997.554 1.994 1.684 2.991 2.946.701 1.25-.604 1.787-1.25 1.384l-2.99-2.991c-.42-.229-.808-.714-1.34-.045l-.714.491c-.158.02-.418.603-.358-.58zM320.357 396.871l5.09-3.17 2.187 3.572c-1.626 2.287-2.73 3.062-4.469 4-1.321.27-1.158-.253-1.484-.569-.926-1.434-.58-2.56-1.324-3.833z",
  fill: "#dbba07",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 0.76
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M327.455 388.344s1.378 1.6 1.608 2.59c.443 1.908.367 4.134-.58 5.848-1.377 2.487-6.237 5.097-6.237 5.097M342.366 375.978s2.302 2.893 3.973 3.348c2.141.584 4.575-.129 6.563-1.116.584-.29 1.428-1.339 1.428-1.339",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.063
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M343.568 397.53c.2.679 4.042 2.165 4.2 3.627.09.84-.83 1.429-.268 2.768.52 1.24 1.277 3.946.893 4.33",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M356.696 383.434s1.814-.202 2.724-.179c1.033.026 3.08.357 3.08.357M370.804 453.076c2.882.053 2.964-1.652 6.16-.625M373.587 431.57c.272.271 1.715 2.91 2.127 3.605.62 1.04 2.679 2.455 2.679 2.455M383.304 413.701c1.145.228 2.291.329 3.437-.267 1.45-.705 3.178-.963 5.223-.715",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.063,
  strokeLinecap: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M330.257 380.8c.581 1.232.855 2.694 2.715 2.967",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.063
});

var SvgPantsIcon = function SvgPantsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 106.751 110.277",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-309.711 -363.788)"
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      marker: "none"
    },
    cx: 325.265,
    cy: 394.406,
    rx: 0.816,
    ry: 0.915,
    color: "#000",
    overflow: "visible",
    fill: "#dbba07",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      marker: "none"
    },
    cx: 325.143,
    cy: 402.834,
    rx: 0.816,
    ry: 0.915,
    color: "#000",
    overflow: "visible",
    fill: "#dbba07",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      marker: "none"
    },
    cx: 330.194,
    cy: 388.881,
    rx: 0.816,
    ry: 0.915,
    color: "#000",
    overflow: "visible",
    fill: "#dbba07",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      marker: "none"
    },
    cx: 341.873,
    cy: 378.401,
    rx: 0.816,
    ry: 0.915,
    color: "#000",
    overflow: "visible",
    fill: "#dbba07",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      marker: "none"
    },
    cx: 354.816,
    cy: 379.222,
    rx: 0.816,
    ry: 0.915,
    color: "#000",
    overflow: "visible",
    fill: "#dbba07",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPantsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pantsIcon.0c9d3d2c.svg";
export { ForwardRef as ReactComponent };